import { Button, Input, Popconfirm } from 'antd';
import { useState } from 'react';
import { useHttp } from '@/shared/hooks/http.hook';

const SearchField = params => {
  const [inputValue, setInputValue] = useState('');
  const [isConfirmVisible, setIsConfirmVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const {
    setValue,
    setTotalData,
    setData,
    setSearcher,
    fetchList,
    actualSegment,
    searchValue,
    setSearchValue,
    setGenerateIdOpen,
  } = params;
  const { request } = useHttp();

  const onSearch = async value => {
    if (!value.length) {
      setSearcher(false);
      fetchList(actualSegment);
      return;
    }

    setLoading(true);
    try {
      setValue(value);
      const url = actualSegment
        ? `/api/device/find_with/${value}?actualSegment=${actualSegment}`
        : `/api/device_offline/find_with/${value}`;
      const response = await request(url);

      if (response.error) {
        setIsConfirmVisible(true);
        setSearchValue(value);
      } else {
        setIsConfirmVisible(false);
        setTotalData(response.count);
        setData(response.rows.map((el, i) => ({ ...el, key: i + 1 })));
        setSearcher(true);
      }
    } catch (err) {
      console.error('Search error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = () => {
    setIsConfirmVisible(false);
    setSearchValue(inputValue);
    setInputValue('');
    setGenerateIdOpen(true);
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' && inputValue.trim() !== '') {
      onSearch(inputValue);
    }
  };

  return (
    <>
      <Input
        placeholder='Поиск'
        allowClear
        style={{
          marginBlock: 10,
          width: '45%',
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        }}
        value={inputValue}
        onChange={e => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <Popconfirm
        title='Устройство не найдено!'
        description={`Хотите создать устройство с ID ${inputValue}?`}
        open={
          isConfirmVisible &&
          inputValue === searchValue &&
          /^[a-zA-Z0-9]{16}$/.test(inputValue) &&
          /[a-zA-Z]/.test(inputValue) &&
          /\d/.test(inputValue)
        }
        onConfirm={handleConfirm}
        onCancel={() => {
          setSearchValue('');
          setInputValue('');
          setIsConfirmVisible(false);
        }}
        okText='Продолжить'
        cancelText='Отмена'
      >
        <Button
          type='primary'
          style={{
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            margin: '10px 2px 10px 0',
          }}
          onClick={() => onSearch(inputValue)}
          disabled={!inputValue.trim() || loading}
          loading={loading}
        >
          Найти
        </Button>
      </Popconfirm>
    </>
  );
};

export default SearchField;
